module.exports = __webpack_public_path__ + "img/centre-services-scolaire-patriotes.212dcee5.png";